


































































































































































import Vue from 'vue'
import SignInUp from '@/components/user/Sign-in-up.vue'
import DividerWithText from '@/components/DividerWithText.vue'
import Block from '@/components/Block.vue'
import moment from 'moment'
import Confirm from '@/components/Confirm.vue'
import EmailValidation from '@/service/EmailValidation'
import SocialLogin from '@/components/user/SocialLogin.vue'
import ContentDialog from '@/components/ContentDialog.vue'
import ExpandableText from '@/components/ExpandableText.vue'

export default Vue.extend({
  name: 'Sign-up',
  components: {
    SignInUp,
    DividerWithText,
    Block,
    Confirm,
    SocialLogin,
    ContentDialog,
    ExpandableText,
  },
  computed: {
    userRestrictionsMessage: function (): string {
      let message = ''

      if (this.enteredWrongDate) {
        message +=
          'In order to European Union restrictions you have to be 16+ to use this kind of application. <b>Do you confirm your age?</b><br>'
      }

      return message
    },
  },
  async mounted() {
    await this.$recaptchaLoaded()
    this.$recaptchaInstance.showBadge()
    this.socialRegistrationInit()
    this.$store.dispatch('countries/load', this.$api);

    const promises = [
      this.$api
        .get('/articles/slug/registration-privacy-policy-short')
        .then((result) => (this.privacyPolicyShort = result.data.content)),
      this.$api
        .get('/articles/slug/registration-privacy-policy-long')
        .then((result) => (this.privacyPolicyLong = result.data.content)),
    ]

    Promise.all(promises).then(() => (this.contentLoaded = true))
  },
  data: () => ({
    contentLoaded: false,
    showPassword: false,
    termsDialog: false,
    birthDateDialog: false,
    privacyPolicyShort: '',
    privacyPolicyLong: '',
    registrationStep: 0,
    user: {
      firstname: '',
      lastname: '',
      birthdayAt: '',
      country: '',
      email: '',
      password: '',
      token: '',
      parentEmail: '',
      termsAndConditions: false,
    },
    signUpBtnLoading: false,
    enteredWrongDate: false,
    formIsValid: false,
    parentsConfirmationUserAges: [16, 17],
    firstNameRules: [(v: string) => !!v || 'First name is required.'],
    lastNameRules: [(v: string) => !!v || 'Last name is required.'],
    birthDateRules: [
      (v: string) => !!v || 'Birth date is required.',
      (v: string) =>
        moment().diff(v, 'years') >= 16 ||
        'You have to be 16 in order to use Tech Master Event.',
    ],
    emailRules: [
      (v: string) => !!v || 'E-mail is required.',
      (v: string) =>
        EmailValidation.isValid(v) || 'Enter correct e-mail address.',
    ],
    passwordRules: [
      (v: string) => !!v || 'Password is required.',
      (v: string) =>
        v.length >= 8 || 'Password must be at least 8 characters long.',
    ],
    termsAndConditionsRules: [
      (v: string) =>
        !!v ||
        'You have to accept our Terms & Conditions in order to use Tech Master Event.',
    ],
    parentEmailRules: [
      (v: string) => !!v || 'E-mail is required.',
      (v: string) =>
        EmailValidation.isValid(v) || 'Enter correct e-mail address.',
    ],
  }),
  methods: {
    isEmptyCountry(country: string) {
      return !!country || 'Country is required.'
    },
    async postNewUser() {
      this.signUpBtnLoading = true

      await this.$recaptchaLoaded()
      this.user.token = await this.$recaptcha('user')

      this.$api
        .post(
          '/users?social=' +
            this.$store.state.socialRegistration.socialRegistration,
          this.user
        )
        .then((response) => {
          this.$router.push('/sign-up-success')
        })
        .catch((err) => {
          if (err.response) {
            if (err.response.data['hydra:description']) {
              this.$store.dispatch(
                'alert/error',
                err.response.data['hydra:description']
              )
              return
            }
            this.$store.dispatch('alert/error', err.response.data.message)
            return
          }
          this.$store.dispatch('alert/error', 'There were some errors.')
        })
        .finally(() => (this.signUpBtnLoading = false))
    },
    signUpClicked() {
      this.enteredWrongDate = false

      const userAge = moment().diff(this.user.birthdayAt, 'years')

      if (this.parentsConfirmationUserAges.includes(userAge)) {
        this.registrationStep = 1
        return
      }

      this.postNewUser()
    },
    signUpStep2Clicked() {
      this.postNewUser()
    },
    socialRegistrationInit() {
      if (this.$store.state.socialRegistration.socialRegistration) {
        this.user.firstname = this.$store.state.socialRegistration.firstname
        this.user.lastname = this.$store.state.socialRegistration.lastname
        this.user.email = this.$store.state.socialRegistration.email
      } else {
        this.user.firstname = ''
        this.user.lastname = ''
        this.user.email = ''
      }
    },
    cancelSocialRegistration() {
      this.$store.dispatch('socialRegistration/finishSocialRegister')
    },
  },
  watch: {
    '$store.state.socialRegistration.socialRegistration': function () {
      this.socialRegistrationInit()
    },
    'user.birthdayAt': function (val) {
      if (moment().diff(val, 'years') < 16) {
        this.enteredWrongDate = true
      }
    },
    birthDateDialog: function (val) {
      val &&
        setTimeout(() => ((this.$refs.datePicker as any).activePicker = 'YEAR'))
    },
  },
  beforeDestroy() {
    this.$recaptchaInstance.hideBadge()
  },
})
